import React from "react";
const AudienceContext = React.createContext();
export default AudienceContext;